import Table from '../Table/index'
import Filter from '../Table/Filter'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faVial } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import { filter } from 'rxjs/operators'
import loadingSVG from '../../media/loading.svg'
import _ from 'lodash'

const columnLayout = [
  // {
  //   field: 'checkbox',
  //   header: '',
  //   type: 'checkbox',
  //   width: '40px',
  //   fieldStyle: 'justify-center'
  // },
  {
    field: 'companyUuid',
    header: 'Id',
    type: 'id',
    style: 'pl3',
    fieldStyle: 'pl3'
  },
  {
    field: 'customer.name',
    header: 'Customer',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
  },
  {
    field: 'claimId',
    header: 'Claim Id',
    type: 'textInput',
    style: 'ph2',
    fieldStyle: 'ph2',
    childClass: 'ph2 pv1',
    width: '150px'
  },
  {
    field: 'claimedDate',
    header: 'Claimed',
    type: 'dateInput',
    style: 'tc',
    fieldStyle: 'ph1 justify-center',
    childClass: 'tc pv1',
  },
  {
    field: 'claimMoisturePercent',
    header: 'M',
    type: 'textInput',
    groupHeader: 'Claim 12%',
    style: 'bg-washed-red tc',
    fieldStyle: 'ph1 tc',
    childClass: 'tc pv1',
    width: '60px'  
  },
  {
    field: 'claimProtein12Percent',
    header: 'P',
    type: 'textInput',
    groupHeader: 'Claim 12%',
    style: 'bg-washed-red tc',
    fieldStyle: 'ph1 tc',
    childClass: 'tc pv1',
    width: '60px'
  },
  {
    field: 'claimFiber12Percent',
    header: 'F',
    type: 'textInput',
    groupHeader: 'Claim 12%',
    style: 'bg-washed-red tc',
    fieldStyle: 'ph1 tc',
    childClass: 'tc pv1',
    width: '60px'  
  },
  {
    field: 'claimMoistureDollars',
    header: 'M',
    type: 'textInput',
    groupHeader: 'Claim Dollars',
    style: 'bg-light-green tc',
    fieldStyle: 'ph1 tc',
    childClass: 'tc pv1',
    width: '90px'  
  },
  {
    field: 'claimProteinDollars',
    header: 'P',
    type: 'textInput',
    groupHeader: 'Claim Dollars',
    style: 'bg-light-green tc',
    fieldStyle: 'ph1 tc',
    childClass: 'tc pv1',
    width: '90px'  
  },
  {
    field: 'claimFiberDollars',
    header: 'F',
    type: 'textInput',
    groupHeader: 'Claim Dollars',
    style: 'bg-light-green tc',
    fieldStyle: 'ph1 tc',
    childClass: 'tc pv1',
    width: '90px'  
  },
  {
    field: 'shipmentInvoiceAmount',
    header: 'Invoice $',
    type: 'textInput',
    groupHeader: '',
    style: 'tc',
    fieldStyle: 'ph1 tc',
    childClass: 'tc pv1',
    width: '90px'  
  },
  // {
  //   field: 'refereeToSend',
  //   header: 'Referee',
  //   type: 'refereeControls',
  //   groupHeader: '',
  //   style: 'tc',
  //   fieldStyle: 'tc',
  // }
]

const AllSamples = (props) => {
  const data = props.shipments?.data
  const loading = props.shipments?.loading
  return (
    <div className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='relative f5 white' icon={faVial} style={{top:-2}}/>
          <div className='pl2 fw7 f6 white'>Incomplete Claims </div>
          <div className='h2'></div>
        </div>
        <div className='flex'>
          <Filter _view={'claimNeedingShipment'} />
          {/* <div className='pv2 ph3 bg-evonik-light-purple br2 white f6 fw5'>
            Attach File to Selected
          </div> */}
          <SubmitButton id={'inc'} className='' 
            responseId='inc'
            defaultChild={ props => (
              <div className='ml2 pv2 ph3 bg-evonik-light-purple br2 white f6 fw5 pointer '
                onClick={e => Dispatch.nextAction('shipments.save')}
              >
                Save
              </div>
            )}
            loadingChild={ props => (
                <div className='mh3 ' style={{width:40, height: 30}}>
                  <img className='w-100 h-100' src={loadingSVG} alt='loading'/>
                </div>
            )}
            errorChild={ props => (
              <div className='pl3 f7 fw4 red tr pointer'>Error</div>
            )}
            loadingStream={
              Dispatch.getAction('Request.saveShipments')
                .pipe(
                  filter(e => !e.variables?.refereeToSend)
                )
              }
            successStream={
              Dispatch.getAction('Response.saveShipments')
                .pipe(
                  filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipments) || !_.isNil(e.data.upsertShipments) ))),
                )
              }
            errorStream={
              Dispatch.getAction('Response.saveShipments')
                .pipe(
                  filter(e => !_.isNil(e.errors)),
                )}
          />
        </div>
      </div>
      <div className='w-100 flex' style={{background: '#f5f3f5'}}>
        <Table _tableName={'incompleteClaim'} _shipments={data} _loading={loading} _columnLayout={columnLayout} {...props}/>
      </div>
    </div>
  )
}

export default AllSamples